const MAX_FILE_UPLOAD_SIZE = 20000000; // 20MB
const BYTES_IN_MB = 1000000;
const MAX_FILE_UPLOAD_SIZE_MB = MAX_FILE_UPLOAD_SIZE / BYTES_IN_MB; // bytes to MB

export {
  MAX_FILE_UPLOAD_SIZE,
  MAX_FILE_UPLOAD_SIZE_MB,
};
